import { AppEnvironment, AWSRegion } from '@moodys/cre-cpm.constants.environment';

export const isTestEnv = (): boolean => process.env.NODE_ENV === 'test';

export const isProductionEnv = (): boolean => process.env.REACT_APP_ENV === 'production';

export const getAppEnvironment = (): AppEnvironment => (process.env.REACT_APP_ENV ?? 'development') as AppEnvironment;

export const getAWSRegion = (): AWSRegion => (process.env.REACT_APP_REGION ?? 'eu') as AWSRegion;
